import type ProductStore from '../AppData/_stores/ProductStore';
import type ViewProductStore from '../AppData/_stores/ViewProductStore';

interface BuildCreateUrlOptions {
  baseSearchParams?: URLSearchParams
  fallbackCreateUrl?: string
  variant?: string
}

function parseFallbackCreateUrl(createUrl?: string) {
  if (!createUrl) {
    return {
      productPath: undefined,
      searchParams: undefined,
    };
  }

  const [pathAndSearch] = createUrl.split('#', 1);
  const queryStart = pathAndSearch.indexOf('?');

  if (queryStart === -1) {
    return {
      productPath: pathAndSearch,
      searchParams: undefined,
    };
  }

  return {
    productPath: pathAndSearch.slice(0, queryStart),
    searchParams: new URLSearchParams(pathAndSearch.slice(queryStart + 1)),
  };
}

export default function buildCreateUrl(
  viewProduct: ViewProductStore | undefined,
  createProduct: ProductStore | undefined,
  createPath: string,
  options?: URLSearchParams | BuildCreateUrlOptions
) {
  const baseSearchParams = options instanceof URLSearchParams ? options : options?.baseSearchParams;
  const fallbackCreateUrl = options instanceof URLSearchParams ? undefined : options?.fallbackCreateUrl;
  const fallback = parseFallbackCreateUrl(fallbackCreateUrl);
  const variant = options instanceof URLSearchParams ? undefined : options?.variant;
  const productPath = (createProduct?.get('url_slug') ?? fallback.productPath ?? viewProduct?.get('url_slug') ?? '').replace(/^\/+/, '');
  const url = createPath.replace(/\/+$/, '') + '/' + productPath;
  const queryParams = new URLSearchParams(fallback.searchParams);

  baseSearchParams?.forEach((value, key) => {
    queryParams.set(key, value);
  });

  if (viewProduct !== undefined) {
    queryParams.set('viewProduct', String(viewProduct.get('id')));
  }

  queryParams.delete('variant');

  if (variant !== undefined) {
    queryParams.set('variant', variant);
  }

  createProduct?.get('availableOptionTypes').forEach(optionType => {
    const optionParam = 'option_' + optionType.get('slug');
    queryParams.delete(optionParam);

    const option = optionType.get('options').find(option => viewProduct?.get('pricingOptions').includes(option.get('id')) === true);

    if (option) {
      queryParams.set(optionParam, option.get('slug'));
    }
  });

  const queryString = queryParams.toString();

  return queryString !== '' ? url + '?' + queryString : url;
}
